import { useNavigate } from 'react-router-dom';
import { etbInt } from '@/lib/money';

interface Props {
    walletBalance: number | null;
    activeGames: number;
    stake: number | null;
    bonus?: number;
    showBack?: boolean;
}

export function GamePods({ walletBalance, activeGames, stake, bonus = 0, showBack = true }: Props) {
    const navigate = useNavigate();

    return (
        <div className="w-pods">
            {showBack && (
                <button type="button" className="w-pod w-pod-back" onClick={() => navigate(-1)} aria-label="Back">
                    <span className="w-pod-label">Back</span>
                    <strong>←</strong>
                </button>
            )}
            <div className="w-pod">
                <span className="w-pod-label">Wallet</span>
                <strong>{walletBalance !== null ? etbInt(walletBalance) : '—'}</strong>
            </div>
            <div className="w-pod">
                <span className="w-pod-label">Active Games</span>
                <strong>{activeGames}</strong>
            </div>
            <div className="w-pod">
                <span className="w-pod-label">Stake</span>
                <strong>{stake !== null ? etbInt(stake) : '—'}</strong>
            </div>
            <div className="w-pod">
                <span className="w-pod-label">Bonus</span>
                <strong>{bonus}</strong>
            </div>
        </div>
    );
}
